import type { FilteredProduct } from '@/api';
import type { ProductFormulation } from '@/constants/products';
import type { PrescriptionPadRules } from '@/state-management/slices/prescriptionAssistant/types';
import { getDosagePrefill } from '@/utils/dosageLimit/getDosagePrefill';

/**
 * The pad item fields every product write sets, so a swap never keeps the replaced product's net weight, dosage or
 * maximum daily dose
 */
export const getPadItemDetailFromProduct = (
  product: FilteredProduct,
  formulation: ProductFormulation | undefined,
  rules: PrescriptionPadRules,
) => ({
  productId: product.id,
  productName: product.productName,
  supplierName: product.supplierName,
  dispenseSize: product.attributes?.dispenseSize,
  ...getDosagePrefill(product.attributes?.dosage ?? '', formulation, rules, {
    source: 'product',
    productId: product.id,
  }),
});
